import WidgetMessage from "./WidgetMessage";
export default WidgetMessage;